/**
 * `ActiveManifestRecord` 빌더 — Phase-2 시드 caller(CLI/어드민) 공용.
 * 타입은 active-manifest.ts 에서 별도 제공(isolated-vm 서버 번들은 타입만 import).
 */
import type { ActiveManifestRecord } from './active-manifest';
import type { ManifestV2 } from './manifest.types';

/** prefix 로 시작하는 첫 컬렉션의 version; 없으면 임의(첫) 컬렉션 version 으로 폴백. */
function versionForPrefix(manifest: ManifestV2, prefix: string): string {
  const entries = Object.entries(manifest.collections);
  const match = entries.find(([key]) => key.startsWith(prefix));
  if (match) return match[1].version;
  return entries[0]?.[1].version ?? '';
}

export function buildActiveManifestRecord(
  manifest: ManifestV2,
  ctx: {
    schema: 'dev' | 'staging' | 'production';
    verse?: string;
    seededBy?: string;
    /** 호출자가 주입(Date.now 직접 호출 회피 — 결정성). */
    seededAt: string;
  }
): ActiveManifestRecord {
  return {
    manifest,
    clientVersion: versionForPrefix(manifest, 'client'),
    serverVersion: versionForPrefix(manifest, 'server'),
    seededAt: ctx.seededAt,
    ...(ctx.seededBy ? { seededBy: ctx.seededBy } : {}),
    schema: ctx.schema,
    ...(ctx.verse ? { verse: ctx.verse } : {}),
  };
}
